<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch102">
<p class="centerImage"><img alt="images" id="img5" src="images/img5.jpg"/></p>
<p class="caption">Maj. Gen. John A. Logan</p>
<p class="caption1"><em class="italic">National Archives</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TriumphandDefeat_ch102.vue?78e2d9f8